import React, { useEffect, useState } from 'react';

import { Spacer, Field, Row, Col, Card } from '@cleartrip/bento';
import { List } from 'components/travelsafe';
import { ViewDetails } from 'components/composite';

import ListBlock from './ListBlock';

import Clevertap from 'analytics';

function PageList({ lists, searchEnabled, placeholder, showMoreText, initListCount }) {
	const [resultList, setResultList] = useState([]);
	const [collapse, setCollapse] = useState(true);

	useEffect(() => {
		if (showMoreText) {
			const initList = lists.slice(0, initListCount);
			setResultList(initList);
		} else {
			setResultList(lists);
		}
	}, [initListCount, showMoreText, lists]);

	function search(e) {
		if (e.target.value.length === 0) {
			const initList = lists.slice(0, initListCount);
			setResultList(initList);
			setCollapse(true);
		} else {
			Clevertap.event('Air_UI_action', {
				action_name: 'country_rules_search',
				action_value: e.target.value.toLowerCase(),
			});
			let resultArr = lists.filter((item) => item.title.toLowerCase().includes(e.target.value.toLowerCase()));
			setResultList(resultArr);
		}
	}

	function reset() {
		setResultList(lists);
		setCollapse(false);
	}

	return (
		<>
			{searchEnabled && (
				<>
					<Spacer className='pt-5' />
					<Row>
						<Col span={12} xs={24}>
							<Field placeholder={placeholder} onChange={(e) => search(e)} />
						</Col>
					</Row>

					<Spacer className='pb-2' />
				</>
			)}

			{resultList && resultList.length>0 &&
				resultList.map((item, sectionIdx) => (
					<List iconUrl={item.iconUrl} key={sectionIdx}>
						{item.summaryList && (
							<ViewDetails>
								<ViewDetails.Compressed>
									<>
										{item.summaryList.title && (
											<>
												<Spacer className='pt-3' />
												<List.Title>{item.summaryList.title}</List.Title>
												<Spacer className='pt-2' />
											</>
										)}
										{item.summaryList.description && (
											<>
												<p
													className='fs-4 c-neutral-700 lh-copy lh-copy--xs'
													dangerouslySetInnerHTML={{
														__html: item.summaryList.description,
													}}
												></p>
												<Spacer className='pt-2' />
											</>
										)}

										{item.summaryList.listItems &&
											item.summaryList.listItems.map(
												(listItem, idx) =>
													item && (
														<List.Item
															className='fs-4'
															key={idx}
															dangerouslySetInnerHTML={{
																__html: listItem,
															}}
														/>
													)
											)}
									</>
								</ViewDetails.Compressed>
								<ViewDetails.Expanded>
									<ListBlock item={item} />
								</ViewDetails.Expanded>
							</ViewDetails>
						)}
						{!item.summaryList && <ListBlock item={item} />}
						{resultList.length - 1 !== sectionIdx && <Spacer className='pt-2' />}
					</List>
				))}

			{resultList && resultList.length === 0 && (
				<Card className='w-50p ba br-4 bc-neutral-100 fs-4 c-neutral-700 p-3'>No matching results found!</Card>
			)}

			{resultList && collapse && resultList.length !== 0 && resultList.length >= initListCount && showMoreText && (
				<p onClick={reset} className='c-pointer fs-4 hover:td-underline fw-500 c-secondary-500 pt-5'>
					{showMoreText}
				</p>
			)}
		</>
	);
}

PageList.defaultProps = {
	lists: [],
	placeholder: '',
	initListCount: 5,
};

export default PageList;
